export const sizeToWidth: Record<string, number> = { sm: 420, lg: 800, xl: 1100 };
